import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M116.353 256.258L116.392 256.164L116.429 256.07L170.709 119.504C170.711 119.5 170.713 119.495 170.714 119.491C176.574 104.841 178.961 96.8732 178.961 87.2844C178.961 77.6921 175.977 68.19 168.702 61.1192C161.47 54.0899 151.772 51.1862 141.708 51.1862H58.5378C49.6097 51.1862 40.7863 53.8962 34.1609 60.4496C27.5183 67.02 24.7499 75.8078 24.7499 84.6853V107.499C24.7499 116.76 27.7075 125.617 34.0728 132.257C40.4781 138.937 49.1782 142.154 58.249 142.154C67.2776 142.154 75.9023 138.868 82.2263 132.2C86.7089 127.474 89.497 121.625 90.7254 115.297H99.3409L53.2212 230.348L53.2172 230.358C51.4329 234.819 50.4518 239.522 50.4518 244.384C50.4518 253.412 53.6261 261.995 59.8794 268.383C66.1607 274.799 74.7447 278.172 83.9509 278.172C97.7921 278.172 110.621 270.111 116.353 256.258Z",
      fill: "white",
      stroke: "#FF9600",
      "stroke-width": "28.8786"
    }, null, -1)
  ])))
}
export default { render: render }